import { render, staticRenderFns } from "./JourneyPreview.vue?vue&type=template&id=0fa804a8&scoped=true"
import script from "./JourneyPreview.vue?vue&type=script&lang=js"
export * from "./JourneyPreview.vue?vue&type=script&lang=js"
import style0 from "./JourneyPreview.vue?vue&type=style&index=0&id=0fa804a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa804a8",
  null
  
)

export default component.exports